import React, { useState, useEffect, useMemo } from "react";
import FabricPreview from "./FabricPreview";
import AdorElGraphic from "control/AdorElGraphic";
import AdorElCustomList from "control/AdorElCustomList";
import AdorElUserAdrrList from "control/AdorElUserAdrrList";
import AdorElDeptAdrrList from "control/AdorElDeptAdrrList";
import AdorElImgList from "control/AdorElImgList";
import AdorElNumber from "control/AdorElNumber";
import AdorElTel from "control/AdorElTel";
import AdorElEmail from "control/AdorElEmail";
import AdorElUrl from "control/AdorElUrl";
import AdorElDate from "control/AdorElDate";
import AdorElText from "control/AdorElText";
import PdfPreview from "./PdfPreview"
import moment from 'moment';


export default function CustomizeFabric({ product, adors, getAdor, updateAdorValue }) {

  const [validate, setValidate] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const handleOpenModel = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Change forcast 
  useEffect(() => {
    // Find listener then trigger action


  }, [adors]);

  const handleSubmit = () => {
    // broadcast validation
    //debugger;
    setValidate((prev) => prev + 1);
    let pass = true;
    handleOpenModel();
    return;

    for (let key in adors) {
      pass = pass && adors[key].is_invalid !== 1;
    }
    if (pass) {
      alert("Pass validation");
    }
  }

  const adorForm = useMemo(() => {
    // debugger;
    if (adors) {
      let rv = [];
      for (let key in adors) {
        const ador = adors[key];
        if (ador.ui_type == "graphic") {
          rv.push(<AdorElGraphic ador={ador} validate={validate} updateAdorValue={updateAdorValue} />);
        }
        else if (ador.ui_type == "custom_list") {
          rv.push(<AdorElCustomList ador={ador} validate={validate} updateAdorValue={updateAdorValue} />);
        }
        else if (ador.ui_type == "user_address_list") {
          rv.push(<AdorElUserAdrrList ador={ador} validate={validate} updateAdorValue={updateAdorValue} />);
        }
        else if (ador.ui_type == "department_address_list") {
          rv.push(<AdorElDeptAdrrList ador={ador} validate={validate} updateAdorValue={updateAdorValue} />);
        }
        else if (ador.ui_type == "image_list") {
          rv.push(<AdorElImgList ador={ador} validate={validate} updateAdorValue={updateAdorValue} />);
        }
        else if (ador.ui_type == "number") {
          rv.push(<AdorElNumber ador={ador} validate={validate} updateAdorValue={updateAdorValue} />);
        }
        else if (ador.ui_type == "tel") {
          rv.push(<AdorElTel ador={ador} validate={validate} updateAdorValue={updateAdorValue} />);
        }
        else if (ador.ui_type == "email") {
          rv.push(<AdorElEmail ador={ador} validate={validate} updateAdorValue={updateAdorValue} />);
        }
        else if (ador.ui_type == "url") {
          rv.push(<AdorElUrl ador={ador} validate={validate} updateAdorValue={updateAdorValue} />);
        }
        else if (ador.ui_type == "date") {
          rv.push(<AdorElDate ador={ador} validate={validate} updateAdorValue={updateAdorValue} />);
        }
        else {
          rv.push(<AdorElText ador={ador} validate={validate} updateAdorValue={updateAdorValue} />);
        }
      }
      return rv;
    }
  }, [adors]);

  return (
    <div className="p-2">
      <h2 className="p-2 text-center">Customize {product.name} </h2>
      <div className="row px-2 ">
        <div className="col-8">
          <FabricPreview adors={adors} updateAdorValue={updateAdorValue} product={product}  />
        </div>

        <div className="col-4">
          {/* adorForm */}
          <div className="px-2 mt-2 text-center">
            <button type="button" className="btn btn-primary" onClick={handleSubmit} >Submit</button>
          </div>
        </div>

      </div>

    </div>
  );
}
